<template>
  <div class="breadcrumb">
    <em class="breadcrumb-item" v-for="(item, index) of breadcrumbData" :key="index">
      <a :href="item.link" class="breadcrumb-inner" v-if="item.link">{{ item.name }}</a>
      <span class="breadcrumb-inner" v-else>{{ item.name }}</span>
      <i class="breadcrumb-separator" v-if="index !== breadcrumbs.length - 1"></i>
    </em>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'Breadcrumb',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      breadcrumbData: []
    }
  },
  watch: {
    breadcrumbs: {
      handler(val) {
        this.breadcrumbData = val
      },
      immediate: true
    },
  },
})
</script>

<style lang="scss" scoped>
@import "./../../assets/style/mixin.scss";

.breadcrumb {
  display: flex;
  align-items: center;
  padding: 20px 0 30px 0;

  em {
    display: flex;
  }

  span {
    font-size: 12px;
    color: #ABABAB;
  }

  a {
    font-size: 12px;
    color: #666;
  }

  i {
    margin: 0 5px;
    display: block;
    width: 16px;
    height: 16px;
    background: url('./../../assets/images/case/arrow.png') 0 0;
  }
}
</style>